import { unref } from 'vue';
import { PRICE_TYPE_COPY } from './constants';
import { updateBadgeData } from './utils';

/**
 * This function parses product response into price data
 * @param {Product} product
 * @param { UiKillswitchesMcom } uiKillSwitches
 * @param { PriceParserOptions } options
 * @returns {TraitPrice}
 */
const parser = (
  product,
  uiKillSwitches = {
    ccfpEnabled: false,
    klarnaPaymentEnabled: false,
    isConsolidatedMasterPageEnabled: false,
    isBigTicketHideInStockOfferFeatureEnabled: false,
    isUpcLevelPromoBadgingEnabled: false,
  },
  options = { iShip: false, disableKlarna: false },
) => {
  // TODO - check if ccfp works on consolidated pages
  const unrefProduct = unref(product);
  const {
    id, detail, traits, pricing, ccfp, department, relationships,
  } = unrefProduct;

  const {
    consolidatedProductComplex: isConsolidatedStandard = false,
    consolidatedMaster = false,
    bigTicketItem = false,
    masterProduct: isMasterProduct = false,
    gwpExperienceEnabled: isGwpExperienceEnabled = false,
    giftCard: isGiftCard = false,
    isMarketPlaceEligible = false,
  } = detail?.flags ?? {};

  const isColorwayOffers = uiKillSwitches.isUpcLevelPromoBadgingEnabled && !isMasterProduct && !isGwpExperienceEnabled && !isGiftCard;
  const isConsolidatedMaster = uiKillSwitches.isConsolidatedMasterPageEnabled && bigTicketItem && consolidatedMaster;
  const isConsolidatedPage = isConsolidatedMaster || isConsolidatedStandard;

  const priceTypeText = pricing?.price?.priceType?.text?.toLowerCase();

  if (priceTypeText && priceTypeText in PRICE_TYPE_COPY) {
    pricing.price.priceType.text = PRICE_TYPE_COPY[priceTypeText];
  }

  const isCCFP = !product?.detail?.flags?.masterProduct && uiKillSwitches.ccfpEnabled && product.ccfp?.ccfpEligible;
  const klarnaEligible = !!(uiKillSwitches.klarnaPaymentEnabled
    && product?.detail?.flags?.klarnaEligible
    && !product?.detail?.flags?.masterProduct
    && !options.iShip
    && !options.disableKlarna);

  updateBadgeData(unrefProduct);

  return {
    id,
    detail,
    traits,
    pricing,
    ccfp,
    department,
    isCCFP,
    klarnaEligible,
    relationships,
    latchkeyData: (isConsolidatedMaster && relationships?.latchKeyToProductMap?.[relationships?.selectedLatchKey]) || {},
    isConsolidatedPage,
    isConsolidatedMaster,
    isConsolidatedStandard,
    isBigTicketHideInStockOfferFeatureEnabled: uiKillSwitches.isBigTicketHideInStockOfferFeatureEnabled,
    isColorwayOffers,
    isMasterProduct,
    isMarketPlaceEligible,
  };
};

export default parser;
